<div class="radio-button border-0 pb-0" id="{{ 'cbx' + item.key }}" *ngFor="let item of allItems">
    <input class="svg-16" type="checkbox" [checked]="item.checked" [disabled]="item.disabled ?? false" (input)="onClick($event, item)">
    <label>
        {{ item.value }}
    </label>
</div>